import React from 'react'

import { Accordion, AccordionSummary, AccordionDetails } from './sidebar-accordion'
import { BlockFieldEdit } from './block-field-edit'

export const HeaderEditAccordion = function ({ block }) {
  return (
    <Accordion square>
      <AccordionSummary data-qa="header-edit-accordion">
        Header
      </AccordionSummary>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field" data-qa="header-edit-accordion-title">
            <BlockFieldEdit block={block} field="title" label="Title" rows={3} />
          </div>
          <div className="full-width-field" data-qa="header-edit-accordion-description">
            <BlockFieldEdit block={block} field="description" label="Description" />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  )
}
